export function initNavScroll(){

  const nav = document.querySelector('.aside__nav--internal');
  if(!nav) return;

  const header = document.querySelector('header');
  const offset = 30;

  const links = nav.querySelectorAll('a[href^="#"]');
  const targets = [];

  // mapear targets
  links.forEach(link => {

    const id = link.getAttribute('href').substring(1);
    const target = document.getElementById(id);

    if(target){
      targets.push({ link, target });
    }

    // scroll suave
    link.addEventListener('click', e => {

      e.preventDefault();

      const headerHeight = header ? header.offsetHeight : 0;

      const top =
        target.getBoundingClientRect().top +
        window.scrollY -
        headerHeight -
        offset;

      window.scrollTo({
        top,
        behavior: 'smooth'
      });

    });

  });

  // primer activo
  if(links.length){
    links[0].classList.add('_active');
  }

  function updateActive(){

    const headerHeight = header ? header.offsetHeight : 0;
    const scroll = window.scrollY + headerHeight + offset + 10;

    let current = 0;

    targets.forEach(({target}, i) => {

      if(scroll >= target.offsetTop){
        current = i;
      }

    });

    links.forEach(link => link.classList.remove('_active'));

    if(targets[current]){
      targets[current].link.classList.add('_active');
    }

  }

  window.addEventListener('scroll', updateActive);
  window.addEventListener('resize', updateActive);

  updateActive();

}